import React from 'react'

let ControllerScheduleLabel = ({children, value, valueClass, colorClass, dark, pulse}) =>
    <div className={"row col-12 p-0 justify-content-between m-1 bg-dark rounded alarm-container " + (dark ? "text-dark " : "text-white ") + (pulse ? "pulse " : "")}>
        <div className={"d-inline-block pt-2 pb-2 pl-3 pr-3 col-8 " + colorClass} >
            {children}
        </div>
        <div className={"d-inline-block pt-2 pb-2 pl-3 pr-3 col-4 text-center " + valueClass}>
            {value}
        </div>
    </div>

export default ControllerScheduleLabel



// WEBPACK FOOTER //
// ./src/components/ui/ControllerScheduleLabel.js